import { Chip, useTheme } from "@mui/material";
import { useAtomValue } from "jotai";
import { SlidersHorizontalIcon } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { portfolioFilterSummary } from "web_myplann/Portfolio/Helpers/portfolioFilterSummary";
import { portfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

export const PortfolioFilterChip: FC = () => {
	const { t } = useResource();
	const theme = useTheme();
	const navigate = useNavigate();
	const filter = useAtomValue(portfolioFilterState);

	const summary = portfolioFilterSummary(filter, t);

	return (
		<Chip
			variant="filter"
			color={summary ? "info" : undefined}
			icon={<SlidersHorizontalIcon size={theme.iconSize.xs} />}
			label={
				summary
					? t(Resources.Portfolio.List.Redesign.filterChipActive, { summary })
					: t(Resources.Portfolio.List.Redesign.filterChip)
			}
			onClick={() => navigate(Routing.Portfolio.PortfolioFilter.path())}
		/>
	);
};
